import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=30090683&scoped=true&"
import script from "./FollowUp.vue?vue&type=script&lang=js&"
export * from "./FollowUp.vue?vue&type=script&lang=js&"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=30090683&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30090683",
  null
  
)

export default component.exports